import React, { useEffect, useState } from 'react'
import './DailerCalling.scss'
// images
import muteFill from '../../../../assets/icons/muteFill.svg'
import microphone from '../../../../assets/icons/microphone.svg'
import dialerPhone from '../../../../assets/icons/dialerPhone.svg'
import callingAIIcon from '../../../../assets/icons/callingAIIcon.svg'
import personCalling from '../../../../assets/icons/personCalling.svg'

const DailerCalling = () => {
    const [calling, setCalling] = useState(true);
    const [callPick, setCallPick] = useState(true);
    // const [callEnd, setCallEnd] = useState(true);

    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    const handleCallEnd = () => {
        setCallPick(false);
    }
    // Calling Timer Start
    useEffect(() => {
        const timer = setInterval(() => {
            setSeconds((prevSeconds) => {
                if (prevSeconds === 59) {
                    setMinutes((prevMinutes) => {
                        if (prevMinutes === 59) {
                            setHours((prevHours) => prevHours + 1);
                            return 0;
                        }
                        return prevMinutes + 1;
                    });
                    return 0;
                }
                return prevSeconds + 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, []);
    const padZero = (value) => (value < 10 ? `0${value}` : value);
    // Calling Timer End

    return (
        <>
            <div className='dialerCalling-main-container'>
                <div className='dialerCalling-header'>
                    <h2>Concrete Restoration</h2>
                    <span></span>
                </div>
                <div className='dialerCalling-center'>
                    <div className='dialerCalling-center-box'>
                        {callPick ? (
                            <div className='AI-bot-box-parent'>
                                <div className='AI-bot-box'>
                                    <img src={callingAIIcon} alt="" />
                                </div>
                                <div id="bars">
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                    <div class="bar"></div>
                                </div>
                                <div className={`Person-bot-box ${!calling ? 'Person-bot-box-shadow' : ''} `}>
                                    <img src={personCalling} alt="" />
                                </div>
                            </div>
                        ) : (
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                                <div className='Person-bot-box'>
                                    <img src={personCalling} alt="" />
                                </div>
                                <div className="counter-container d-flex">
                                    <div className="counter" id="hours">00</div>
                                    <div className="colon">:</div>
                                    <div className="counter" id="minutes">02</div>
                                    <div className="colon">:</div>
                                    <div className="counter" id="seconds">15</div>
                                </div>
                            </div>
                        )}


                    </div>
                    {
                        calling ? (
                            <h4>Calling. . . .</h4>
                        ) : callPick ? (
                            <div className="counter-container d-flex">
                                <div className="counter" id="hours">{padZero(hours)}</div>
                                <div className="colon">:</div>
                                <div className="counter" id="minutes">{padZero(minutes)}</div>
                                <div className="colon">:</div>
                                <div className="counter" id="seconds">{padZero(seconds)}</div>
                            </div>
                        ) : (
                            <></>
                        )
                        // calling ? (
                        //     <h4>Calling. . . .</h4>
                        // ) : callPick ? (
                        //     <h4>Ongoing</h4>
                        // ) : (
                        //     <div className="counter-container d-flex">
                        //         <div className="counter" id="hours">{padZero(hours)}</div>
                        //         <div className="colon">:</div>
                        //         <div className="counter" id="minutes">{padZero(minutes)}</div>
                        //         <div className="colon">:</div>
                        //         <div className="counter" id="seconds">{padZero(seconds)}</div>
                        //     </div>
                        // )
                    }
                    <p className='numQueue-txt'>Next Number in Queue</p>
                    <p className='numQueue-number'>+16102347269</p>
                </div>
                <div className='dialerCalling-bottom'>
                    <div className='dailerCalling-bottom-options'>
                        <div><img src={muteFill} alt="" /></div>
                        <div><img src={microphone} alt="" /></div>
                        <div onClick={handleCallEnd}><img src={dialerPhone} alt="" /></div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DailerCalling